import React from "react"
import {
  HomeContainer,
  NameText,
  DescriptionContainer,
  DescriptionText,
} from "./styles"

const Home = () => (
  <HomeContainer>
    <NameText>Anumitha Apollo</NameText>
    <DescriptionContainer>
      <DescriptionText>
        Hey there! I’m a designer and a creator.
        <br /> I’m documenting what I learn and <br />
        things I find interesting here.
      </DescriptionText>
    </DescriptionContainer>
  </HomeContainer>
)

export default Home
